export type AiAssistantErrorCode =
  | 'WORKFLOW_POLL_EXHAUSTED'
  | 'WORKFLOW_ERROR_STATUS'
  | 'WORKFLOW_NOT_FOUND'
  | 'WORKFLOW_UNEXPECTED_STATUS'
  | 'WORKFLOW_MALFORMED_RESPONSE'
  | 'WORKFLOW_REQUEST_FAILED';

export class AiAssistantError extends Error {
  readonly code: AiAssistantErrorCode;
  readonly context?: Record<string, unknown>;

  constructor(
    code: AiAssistantErrorCode,
    message: string,
    context?: Record<string, unknown>,
    cause?: unknown,
  ) {
    super(message);
    this.name = 'AiAssistantError';
    this.code = code;
    this.context = context;

    // Preserve cause (TS 4.x support)
    if (cause && (this as any).cause === undefined) {
      (this as any).cause = cause;
    }
  }
}

export function isAiAssistantError(err: unknown): err is AiAssistantError {
  return err instanceof AiAssistantError;
}
